import { schema } from "normalizr";

// Following are generic schemas used by Normalizr to normalize either of EvaluationForm, AssessmentForm or SurveyForm
const answerOption = new schema.Entity("answerOptions");
const multipleSelectOptionQuestions = new schema.Entity(
    "multipleSelectOptionQuestions"
);
export const questions = new schema.Entity("questions", {
    answerOptions: [answerOption],
    multipleSelectOptionQuestions: [multipleSelectOptionQuestions],
});
const questionGroups = new schema.Entity("questionGroups", {
    questions: [questions],
});
const qualityForm = new schema.Entity("qualityForm", {
    questionGroups: [questionGroups],
});

export const normalizedQualityForm = new schema.Entity("form", {
    questionGroups: [questionGroups],
    questions: [questions],
    answerOptions: [answerOption],
    multipleSelectOptionQuestions: [multipleSelectOptionQuestions],
    form: [qualityForm],
});

export const templates = new schema.Entity("templates");
export const normalizedTemplates = new schema.Entity("composerTemplate", {
    entities: [templates],
});
